<div
  id="section-updated"
  class="identification-number-log information-tabs-table"
>
  @if (logItems.length) {
    <table
      mat-table
      [dataSource]="logItems"
    >
      <caption></caption>

      <ng-container matColumnDef="updated_at">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'TRANS__FIELD__UPDATED_AT' | translate }}
        </th>

        <td mat-cell *matCellDef="let element">
          {{element['updated_at']}}
        </td>
      </ng-container>

      <ng-container matColumnDef="updated_by">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'TRANS__FIELD__UPDATED_BY' | translate }}
        </th>

        <td mat-cell *matCellDef="let element">
          {{element['updated_by']}}
        </td>
      </ng-container>

      <ng-container matColumnDef="to_identification_number">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'TRANS__FIELD__TO_IDENTIFICATION_NUMBER' | translate }}
        </th>

        <td mat-cell *matCellDef="let element">
          {{element['to_identification_number']}}
        </td>
      </ng-container>

      <ng-container matColumnDef="from_identification_number">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'TRANS__FIELD__FROM_IDENTIFICATION_NUMBER' | translate }}
        </th>

        <td mat-cell *matCellDef="let element">
          {{element['from_identification_number']}}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  }
  @else {
    <div>
      <span>
        {{ 'TRANS__OBJECT_UPDATE_LOG__NO_REGISTERED_CHANGES' | translate }}
      </span>
    </div>
  }
</div>
